import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon11: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 15.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 15 20" width={width} height={height} {...props}>
      <Path
        d="M13.5938 0C14.3704 0 15 0.610889 15 1.36359V19.5448C15 19.9339 14.5278 20.143 14.2242 19.8884L7.5 14.2377L0.775753 19.8884C0.4722 20.143 0 19.9339 0 19.5448V1.36359C0 0.610889 0.629597 0 1.40625 0H13.5938ZM13.5938 0.909061H1.40625C1.14737 0.909061 0.9375 1.11269 0.9375 1.36359V18.5494L7.19297 13.2923C7.36922 13.1441 7.63078 13.1441 7.80703 13.2923L14.0625 18.5494V1.36359C14.0625 1.11269 13.8526 0.909061 13.5938 0.909061Z"
        fill="#F3123C"
      />
    </Icon>
  )
}
